<ifc-app-scroll-container [widgetsWithTopHeader]="true">
  <div class="layout margin flex-std" [@routerTransition]="'fly'">
    <ifb-panel>
      <ifb-card>
        <ifb-advisor-info-widget [data]="data"></ifb-advisor-info-widget>
      </ifb-card>
    </ifb-panel>
  </div>
</ifc-app-scroll-container>
